import { use_slice_search, use_slice_user } from '@/hooks/store/use_slices';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { STokensListItem } from './STokensListItem';

export function STokensList() {
  const { search_current } = use_slice_search(['search_current']);
  const { user_settings } = use_slice_user(['user_settings']);

  function render_items() {
    return search_current.tokens.filter(filter_tokens).map(item => {
      return <STokensListItem key={item.word_english} item={item} />;
    });
  }

  function filter_tokens(token: DTO__token) {
    let need_show_token = true;

    if (user_settings.search_prompt_hide_unused_tokens) {
      need_show_token = !token.is_hidden;
    }

    return need_show_token;
  }

  return <> {render_items()}</>;
}
